module.exports = __webpack_public_path__ + "static/media/allalerts_active_assailant_hover.3c405612.svg";